import React from 'react'
import classNames from 'classnames/bind'
import Label from 'elements/Label'
import * as styles from './FormField.scss'

const cx = classNames.bind(styles)

interface IProps {
  styleType?: string,
  isErrorShown: boolean,
  isPromptShown: boolean,
  required: boolean,
  errorMessage: string,
  promptMessage: string,
  label: string | React.ReactChild,
}

class FormField extends React.Component<IProps, {}> {
  public render () {
    const {
      isErrorShown,
      errorMessage,
      promptMessage,
      children,
      label,
      required,
      inline,
      hint,
      isPromptShown,
    } = this.props

    return (
      <div className={cx('root', { inline })}>
        <Label required={required}>{label}</Label>
        {children}
        <div />
        {isPromptShown && (
            <div className={styles.prompt}>
              {promptMessage}
            </div>
          )
        }
        {isErrorShown
          ? (
            <div className={styles.errorMessage}>
              {errorMessage}
            </div>
          )
          : hint
            ? (<div className={styles.hint}>
                {hint}
              </div>)
            : (<div className={styles.space} />)
        }
      </div>
    )
  }
}

export default FormField
